module.exports = __webpack_public_path__ + "static/media/sendIcon.c7af4c7a.svg";